module.exports = __webpack_public_path__ + "static/media/hamburger.939648f0.svg";